export default "__VITE_ASSET__BCrDW3U___"